import { useState, useEffect } from 'react'
import Cookies from 'universal-cookie'
import COOKIE_NAME, { WITSBY_PAYWALL_COOKIE } from '../../const/cookie'
// import COOKIE_NAME, { ACTIVATE_COOKIE_NAME } from '../../const/cookie'
import useLocalStorage from './useLocalStorage'

// test vercel

const cookies = new Cookies()

const usePaywall = (article, premium) => {
  const cookieData = cookies.get(COOKIE_NAME)
  const witsbyPaywallCookie = cookies.get(WITSBY_PAYWALL_COOKIE)
  const isLoggedIn = !!cookieData
  const [remaining, setRemaining] = useState(1000)
  const isUnlimited =
    remaining > 100 ||
    !premium ||
    !!cookieData?.isELBadgeMember ||
    !!witsbyPaywallCookie
  // remaining > 100 ||
  // !premium ||
  // !!cookieData?.isPaywallMember ||
  // !!cookieData?.isActivateSubscriber ||
  // (!isLoggedIn && !!cookies.get(ACTIVATE_COOKIE_NAME))

  const [localHistory, setLocalHistory] = useLocalStorage('paywall', [])

  /**
   *
   * @param {Array} articleList - previous history for visiting articles
   * @param {Number} within - days to get visit history within last X days
   * @returns {Array}
   */
  const getHistoryWithin = (articleList, within = 30) =>
    articleList?.filter(
      (item) => item?.visit > Date.now() - within * 24 * 60 * 60 * 1000
    ) || []

  useEffect(() => {
    let updatedHistory = getHistoryWithin(localHistory)
    if (
      premium &&
      localHistory?.findIndex((item) => item?.slug === article) === -1 &&
      !isUnlimited
    ) {
      updatedHistory = [...updatedHistory, { slug: article, visit: Date.now() }]
    }
    setLocalHistory(updatedHistory)
    setRemaining(
      // 5 - updatedHistory?.length
      1 - updatedHistory?.length
      // isLoggedIn ? 5 - updatedHistory?.length : 3 - updatedHistory?.length
    )
  }, [article, premium, isUnlimited, isLoggedIn])

  return {
    remaining,
    isLoggedIn,
    expired: !isUnlimited && remaining < 0 ? true : false,
    isUnlimited,
  }
}

export default usePaywall
